import { create } from "zustand";

export const EducationStore = create((set) => ({
  nivelEscolaridadeValue: null,
  matriculaEscolaValue: null,
  qualidadeEscolasRuraisValue: null,

  educationMapImage: null,
  nivelEscolaridadeImage: null,
  matriculaEscolaImage: null,
  qualidadeEscolasRuraisImage: null,

  setNivelEscolaridadeValue: (val) => set({ nivelEscolaridadeValue: val }),

  setMatriculaEscolaValue: (val) => set({ matriculaEscolaValue: val }),

  setQualidadeEscolasRuraisValue: (val) =>
    set({ qualidadeEscolasRuraisValue: val }),


  setEducationMapImage: (img) => set({ educationMapImage: img }),

  setNivelEscolaridadeImage: (img) => set({ nivelEscolaridadeImage: img }),

  setMatriculaEscolaImage: (img) => set({ matriculaEscolaImage: img }),

  setQualidadeEscolasRuraisImage: (img) =>
    set({ qualidadeEscolasRuraisImage: img }),

  reset: () =>
    set({
      nivelEscolaridadeValue: null,
      matriculaEscolaValue: null,
      qualidadeEscolasRuraisValue: null,
    }),
}));
